import datepicker from '../../Gull/Framework/datepicker.js';

const opbouwschema = {
	/**
	 * Initializes the conditionalQuestions by hiding specified containers and removing validation requirements from selects and inputs.
	 *
	 * @returns {void}
	 */
	init: function () {
		opbouwschema.initEvents();
	},

	/**
	 * Initializes event listeners for various form-related events such as change, blur, keyup, and form submission.
	 *
	 * @returns {void}
	 */
	initEvents: function () {
		document.addEventListener(
			'blur',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum')) {
						opbouwschema.get();
						break;
					}
				}
			},
			false
		);

		document.addEventListener(
			'keyup',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum')) {
						opbouwschema.get();
						break;
					}
				}
			},
			false
		);

		document.addEventListener(
			'blur',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren')) {
						opbouwschema.get();
						break;
					}
				}
			},
			false
		);

		document.addEventListener(
			'keyup',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren')) {
						opbouwschema.get();
						break;
					}
				}
			},
			false
		);

		document.addEventListener(
			'click',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('#opbouwSchemaToevoegen')) {
						opbouwschema.add();
						break;
					}
				}
			},
			false
		);

		document.addEventListener(
			'click',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('.opbouw-schema-item-verwijder')) {
						opbouwschema.delete(event);
						break;
					}
				}
			},
			false
		);
	},

	/**
	 * Retrieves data from the 'opbouwSchemaContainer' and updates the 'opbouwSchema' input field.
	 * Uses a setTimeout to delay the retrieval, likely for asynchronous purposes.
	 *
	 * @returns {void}
	 */
	get: function () {
		setTimeout(function () {
			var opbouwSchema = {};
			var elements = document.querySelectorAll('#opbouwSchemaContainer .opbouw-schema-item');
			for (var i = 0; i < elements.length; i++) {
				var childElements = elements[i].getElementsByClassName('opbouw-schema-item-input');
				var period = {};
				for (var a = 0; a < childElements.length; a++) {
					var key = childElements[a].getAttribute('data-opbouw-key');
					var val = childElements[a].value;
					period[key] = val;
				}
				opbouwSchema['periode_' + (i + 1)] = period;
			}
			document.getElementById('opbouwSchema').value = JSON.stringify(opbouwSchema);
		}, 250);
	},

	/**
	 * Adds a new opbouw schema item to the 'opbouwSchemaContainer'.
	 * Initializes necessary elements and event listeners for the added item.
	 *
	 * @returns {void}
	 */
	add: function () {
		const clone = document.querySelector('.opbouw-schema-item').cloneNode(true);
		const container = document.getElementById('opbouwSchemaContainer');

		container.appendChild(clone);

		const buttonDelete = document.querySelector('.opbouw-schema-item:last-child .opbouw-schema-item-verwijder');
		buttonDelete.classList.remove('invisible');

		document.querySelector('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum').value = '';
		document.querySelector('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren').value = '';

		datepicker.init(container);
	},

	/**
	 * Deletes the opbouw-schema item from the DOM based on the provided event.
	 *
	 * @param {Event} event - The event triggering the deletion.
	 *
	 * @returns {void}
	 */
	delete: function (event) {
		const el = event.target.closest('.opbouw-schema-item');
		el.parentNode.removeChild(el);
	},
};

export default opbouwschema;
